

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const loginApi = () => `${BASE_URL}/login`;
// Vendors API
export const getVendors = () => `${BASE_URL}/vendors`;
export const createVendor = () => `${BASE_URL}/vendors/create`;
export const updateVendor = (id) => `${BASE_URL}/vendors/update/${id}`;
export const deleteVendor = (id) => `${BASE_URL}/vendors/delete/${id}`;
export const getVendor = (id) => `${BASE_URL}/vendors/view/${id}`;
export const getVendordetail = (id) => `${BASE_URL}/vendors/detail/${id}`;

//Assign asset to vendor
export const createAssetAssign = () => `${BASE_URL}/assets/assign-to-vendor`;
// vendor status update
export const updateVendorStatus = (id) => `${BASE_URL}/vendors/update-status/${id}`;
//Dashboard get Api
export const getDashboard = () => `${BASE_URL}/dashboard`;

//register Vendor API without login
export const registerVendor = () => `${BASE_URL}/vendor/register`;
// Reminders API
export const getReminders = () => `${BASE_URL}/reminders`;
export const createReminder = () => `${BASE_URL}/reminders/create`;
export const updateReminder = (id) => `${BASE_URL}/reminders/update/${id}`;
export const deleteReminder = (id) => `${BASE_URL}/reminders/delete/${id}`;
export const getReminder = (id) => `${BASE_URL}/reminders/view/${id}`;

// Assets API
export const getAssets = () => `${BASE_URL}/assets`;
export const createAsset = () => `${BASE_URL}/assets/create`;
export const updateAsset = (id) => `${BASE_URL}/assets/update/${id}`;
export const deleteAsset = (id) => `${BASE_URL}/assets/delete/${id}`;
export const getAsset = (id) => `${BASE_URL}/assets/view/${id}`;

// Files API
export const getFiles = () => `${BASE_URL}/files`;
export const createFile = () => `${BASE_URL}/files/create`;
export const updateFile = (id) => `${BASE_URL}/files/update/${id}`;
export const deleteFile = (id) => `${BASE_URL}/files/delete/${id}`;
export const getFile = (id) => `${BASE_URL}/files/view/${id}`;
export const downloadFile = (id) => `${BASE_URL}/files/download/${id}`;

// Time off API
export const getTimeOffs = () => `${BASE_URL}/timeoff`;
export const createTimeOff = () => `${BASE_URL}/timeoff/create`;
export const updateTimeOff = (id) => `${BASE_URL}/timeoff/update/${id}`;
export const deleteTimeOff = (id) => `${BASE_URL}/timeoff/delete/${id}`;
export const getTimeOff = (id) => `${BASE_URL}/timeoff/view/${id}`;
export const updateTimeOffStatus = (id) => `${BASE_URL}/timeoff/update-status/${id}`;
//  Contracts APi
export const getContracts = () => `${BASE_URL}/contracts`;
export const createContract = () => `${BASE_URL}/contracts/create`;
export const updateContract = (id) => `${BASE_URL}/contracts/update/${id}`;
export const deleteContract = (id) => `${BASE_URL}/contracts/delete/${id}`;
export const getContract = (id) => `${BASE_URL}/contracts/view/${id}`;
//  Notification APi
export const getNotifications = () => `${BASE_URL}/notifications`;

//  Project Annoucement  APi
export const getProjectAnnoucements = () => `${BASE_URL}/announcements`;
export const createProjectAnnoucement = () => `${BASE_URL}/announcements/create`;
export const updateProjectAnnoucement = (id) => `${BASE_URL}/announcements/update/${id}`;
export const deleteProjectAnnoucement = (id) => `${BASE_URL}/announcements/delete/${id}`;
export const getProjectAnnoucement = (id) => `${BASE_URL}/announcements/view/${id}`;
export const createProjectAnnoucementEmail = () => `${BASE_URL}/announcements/send-emails`;
export const getProjectAnnoucementVendors = (id) => `${BASE_URL}/announcements/${id}/vendors`;

// User Profile API
export const updateUserProfile = (id) => `${BASE_URL}/users/update/${id}`;
export const getUserProfile = (id) => `${BASE_URL}/users/view/${id}`;
// get vendor list for the dropdown
export const getVendorList = () => `${BASE_URL}/get-vendors`;

//fetch template
export const getFetchTemplate= () => `${BASE_URL}/contracts/fetch-templates`;
export const  getFetchContractsTemplate= () => `${BASE_URL}/contracts/agreements`;

// fetch Contracts Counts API
export const  getFetchContractsCounts= () => `${BASE_URL}/contracts/count`;